import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import DatePicker from '../DatePicker/DatePicker'

const handleChangeRef = (name, values = {}, setFieldValue) => {
  const newValue = `${values.year}${values.month}`

  setFieldValue(name, newValue)
}

const getCurrentValueRef = (value) => {
  const year = value.substring(0, 4)
  const month = value.substring(4, 6)

  return { year, month }
}

const DatePickerField = (props) => {
  const { field: { name = '', value } = {}, form: { setFieldValue } = {} } =
    props

  const initialValue = useMemo(() => getCurrentValueRef(value), [value])

  const handleChange = useCallback((values) =>
    handleChangeRef(name, values, setFieldValue)
  )

  return (
    <DatePicker tag applyFilter={handleChange} initialValue={initialValue} />
  )
}

DatePickerField.defaultProps = {
  field: {
    name: '',
    value: ''
  },
  form: {
    setFieldValue: null
  }
}

DatePickerField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func
  })
}

export default DatePickerField
